<template>
    <div id="evaluacion-respuestas">
    <v-card color="base">
        <v-card-title class="secondary--text"> Estatus de Observación </v-card-title>
        <v-card-text>
            <span class="secondary--text"> ¿Desea actualizar el estatus? </span>
            <v-divider></v-divider>
            <div style="display: inline-block;">
            <span class="font-weight-bold azul2--text">
                {{mensaje}}
            </span>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
            @click="NoAccionEstatus"
            tipo="formCancelar"
            label="No"
            class="mr-3">
            </custom-button>
            <custom-button
            @click="SiAccionEstatus"
            tipo="formAceptar"
            label="Si"
            >
            </custom-button>
        </v-card-actions>
    </v-card>
    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EvaluacionRespuestas',
  props: {
    mensaje: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  methods: {
    NoAccionEstatus() {
      this.$emit('cerrarVentanaEvaluacionRespuestas');
    },
    SiAccionEstatus() {
      this.$emit('botonActualizaEstatus');
    },

  },
};
</script>
